// src/pages/AdminPage.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../components/admin/AdminLayout";

export default function AdminPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("petugas"); // default tab
  const [sidebarOpen, setSidebarOpen] = useState(false); // for mobile

  const handleLogout = () => {
    localStorage.removeItem("isAdmin");
    navigate("/", { replace: true });
  };

  return (
    <AdminLayout
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      sidebarOpen={sidebarOpen}
      setSidebarOpen={setSidebarOpen}
      handleLogout={handleLogout}
    />
  );
}
